import FlowViewSidePanel from 'automation-ui-canvas/containers/flow-views/FlowViewSidePanel';
import FlowViewCanvas from 'automation-ui-canvas/containers/FlowViewCanvas';
import { generatePath, useHistory } from 'react-router-dom';
import { useCallback } from 'react';
import { CANVAS_ROOT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlowViewDataManager = ({
  flow,
  config,
  canvasScrollElementRef
}) => {
  const history = useHistory();
  const viewData = config.useGetViewData({
    flow
  });
  const onCancel = useCallback(() => {
    if (config.onCancel) {
      config.onCancel(history, flow.flowId);
    } else {
      history.push({
        pathname: generatePath(CANVAS_ROOT, {
          screen: 'edit',
          flowId: flow.flowId
        }),
        search: history.location.search
      });
    }
  }, [history, flow.flowId, config]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FlowViewCanvas, {
      canvasScrollElementRef: canvasScrollElementRef,
      config: config,
      flow: flow,
      onCancel: onCancel,
      viewData: viewData
    }), config.sidePanel && /*#__PURE__*/_jsx(FlowViewSidePanel, {
      flow: flow,
      canvasScrollElementRef: canvasScrollElementRef,
      sidePanelConfig: config.sidePanel,
      onCancel: onCancel,
      viewData: viewData
    })]
  });
};
export default FlowViewDataManager;